import { connect } from 'react-redux';
import App from '../Components/App';
import { AppState } from '../../../Configs/Redux/AppState';
import { bindActionCreators } from 'redux';
import { fetchUser } from '../Actions/Actions';
import { IUser } from '../Interfaces/IUser';
import { ReduxAction, ReduxDispatch } from '../../../Configs/Redux/Types';
import * as Sentry from '@sentry/react';
import { getToken } from '../../../__core/Providers/Token/GetToken';

export type AppStateToProps = {
  user: IUser;
  token: string;
};

export type AppDispatchToProps = {
  actions: {
    fetchUser: () => ReduxAction<Promise<unknown>>;
  };
};

const mapStateToProps = (store: AppState): AppStateToProps => {
  const {
    App: { user },
  } = store;

  return { user, token: getToken() };
};

const mapDispatchToProps = (dispatch: ReduxDispatch): AppDispatchToProps => ({
  actions: bindActionCreators({ fetchUser }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sentry.withProfiler(App));
